module.exports = __webpack_public_path__ + "media/theme/icon__status--wait-efaec051.svg";